import ajax from '../http/ajax'

export const getCarNoBelongTo = (data) => {
    return ajax.get('getCarNoBelongTo', {
        'lng': data.lng,    // 经度
        'lat': data.lat,    // 纬度 }).then(res => {
    })
}
